import { IntegrationConfig } from '@services/integration-manager.service';

export const SLAUGHTERHOUSE_INTEGRATION_CONFIGS: IntegrationConfig[] = [
  { name: 'HubSpot', topic: 'hubspot-company', step: 1 },
  { name: 'Netvisor', topic: 'netvisor-company', step: 2 },
  { name: 'HJC', topic: 'hjc-company', step: 2 },
  { name: 'Helos 2.0', topic: 'helos-company', step: 2 }
];

export const HAULIER_INTEGRATION_CONFIGS: IntegrationConfig[] = [
  { name: 'HubSpot', topic: 'hubspot-company', step: 1 },
  { name: 'HJC', topic: 'hjc-company', step: 2 },
  { name: 'Helos 2.0', topic: 'helos-company', step: 2 }
];

export const BYPRODUCT_INTEGRATION_CONFIGS: IntegrationConfig[] = [
  { name: 'Helos 2.0', topic: 'helos-byproduct', step: 1 },
  { name: 'HJC', topic: 'hjc-company', step: 2 }
];
